// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__l08dX","rootCenter":"LoadMoreObserver_rootCenter__253CY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1s3Mu"};